"use client";

import { useEffect } from "react";
import Link from "next/link";
import { Phone, X } from "lucide-react";
import { Logo } from "./Logo";
import { site } from "@/content/site";

type MobileMenuProps = {
  open: boolean;
  onClose: () => void;
  links: { label: string; href: string }[];
};

export function MobileMenu({ open, onClose, links }: MobileMenuProps) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-canvas-light dark:bg-canvas-dark flex flex-col md:hidden">
      <div className="flex items-center justify-between px-4 md:px-6 h-16">
        <Logo />
        <button
          type="button"
          onClick={onClose}
          aria-label="Close menu"
          className="w-10 h-10 rounded-xl bg-surface-light dark:bg-surface-dark border border-line-light dark:border-line-dark flex items-center justify-center"
        >
          <X className="w-5 h-5 text-brand-400" />
        </button>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center gap-8 px-4">
        {links.map((link) => (
          <Link
            key={link.label}
            href={link.href}
            onClick={onClose}
            className="font-display text-[28px] font-bold text-ink-light dark:text-ink-dark hover:text-brand-400 transition-colors"
          >
            {link.label}
          </Link>
        ))}
      </div>
      <div className="px-4 pb-8 pt-4 flex items-center justify-center">
        <a
          href={`tel:${site.socials.phone}`}
          className="flex items-center gap-2.5 px-6 py-3.5 rounded-full bg-brand-gradient text-white font-body text-[14px] font-semibold shadow-button"
        >
          <Phone className="w-4 h-4" />
          Let&rsquo;s Talk
        </a>
      </div>
    </div>
  );
}
